import React, { useEffect, useContext, useState } from "react";
import NewsTab from "../components/News/NewsTab";
import styles from "../styles/News/News.module.css";
import NewsContext from "../context/News/NewsContext";
import NewsItem from "../components/News/NewsItem";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../components/Loader";
import { AiOutlineUp } from "react-icons/ai";
import ScrollToTop from "react-scroll-to-top";
// import AccordionItem from "../components/AccordionItem"
import AccordionItem from "../components/AccordionItem";
import Topics from "../components/Topics";
import _ from "lodash";
const News = () => {
  const {
    getNews,
    news,
    setNewsPage,
    newsPage,
    filterType,
    clearNews,
    topics,
    getTopics,
    topicNews,
    getNewsByTopic,
    setFilterType,
    topicsLoading,
  } = useContext(NewsContext);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleOpen = () => {
    setShow(true);
  };
  const setActive = (name) => {
    setFilterType(name);
  };
  useEffect(() => {
    if (!topics) {
      getTopics();
    }
    setNewsPage(1);
    clearNews();

    if (topics?.includes(filterType)) {
      getNewsByTopic(1);
    } else {
      getNews(1);
    }
    //eslint-disable-next-line
  }, [filterType]);
  const fetchMoreData = () => {
    // a fake async api call like which sends
    // 20 more records in 1.5 secs
    setNewsPage(newsPage + 1);
    setTimeout(() => {
      getNews(newsPage + 1);
    }, 2000);
  };
  const fetchMoreData1 = () => {
    // a fake async api call like which sends
    // 20 more records in 1.5 secs
    setNewsPage(newsPage + 1);
    setTimeout(() => {
      getNewsByTopic(newsPage + 1);
    }, 2000);
  };
  return (
    <div className={styles.News}>
      <div className={styles.News__container}>
        {show && <Topics close={handleClose} setActiveTopic={setActive} />}
        <ScrollToTop smooth component={<AiOutlineUp />} />
        <section className={styles.News__section}>
          <h1 style={{ fontSize: "24px", letterSpacing: "0.8px" }}>News</h1>
          <div className={styles.News__tabContainer}>
            {/* <div className={styles.prev}>
<IoChevronBackCircleSharp size={26}/>
    </div> */}
            {/*     
    <div className={styles.forward}>
              <IoChevronForwardCircleSharp size={26} />
            </div> */}
            {[
              { name: "All" },
              { name: "Positive" },
              { name: "Negative" },
              { name: "Neutral" },
              { name: "Events" },
              { name: "Topics" },
            ].map((d, index) => (
              <NewsTab name={d.name} key={index} Open={handleOpen} />
            ))}
          </div>
          <div>
            {news && news.length > 0 ? (
              <InfiniteScroll
                dataLength={news && news.length}
                next={fetchMoreData}
                hasMore={news && !Boolean(news.length % 10)}
                loader={newsPage > 1 && <Loader />}
                // scrollThreshold="300px"
                // scrollableTarget="scrollableDiv"
                // style={{ marginBottom: "50px" }}
              >
                {news.map((d, index) =>
                  filterType !== "Events" ? (
                    <NewsItem
                      key={index}
                      imgUrl={d.image_url}
                      desc={d.text}
                      src={d.source_name}
                      pdate={d.date}
                      title={filterType !== "Events" ? d.title : d.event_name}
                      url={d.news_url}
                      sentiment={d.sentiment}
                      show={true}
                    />
                  ) : (
                    <AccordionItem
                      key={index}
                      heading={d.event_name}
                      content={d.text}
                      hasNews={d.hasNews}
                      eventNews={d.hasNews && d.eventNews}
                      pdate={d.date}
                      show={false}
                    />
                  )
                )}
              </InfiniteScroll>
            ) : (
              !topics?.includes(filterType) &&
              filterType !== "Topics" && (
                <div style={{ marginTop: "50px" }}>
                  <Loader />
                </div>
              )
            )}

            {    (topics?.includes(filterType)) && (
              <div>
                <h1  style={{ margin: "20px 0 15px 0" }}>Topic Name: {_.startCase(_.toLower(filterType))}</h1>
                <span>
                  {" "}
                  Select a{" "}
                  <span
                    onClick={handleOpen}
                    style={{ color: "#8d0792", cursor: "pointer" }}
                  >
                    Topic
                  </span>
                </span>
              </div>
            )}
            {topicsLoading ? (
              <Loader />
            ) : topicNews && topicNews.length > 0 ? (
              <InfiniteScroll
                dataLength={topicNews && topicNews.length}
                next={fetchMoreData1}
                hasMore={topicNews && !Boolean(topicNews.length % 10)}
                loader={newsPage > 1 && <Loader />}
                // scrollThreshold="300px"
                // scrollableTarget="scrollableDiv"
                // style={{ marginBottom: "50px" }}
              >
                {topicNews.map((d, index) => (
                  <NewsItem
                    key={index}
                    imgUrl={d.image_url}
                    desc={d.text}
                    src={d.source_name}
                    pdate={d.date}
                    title={filterType !== "Events" ? d.title : d.event_name}
                    url={d.news_url}
                    sentiment={d.sentiment}
                    show={true}
                  />
                ))}
              </InfiniteScroll>
            ) : (
              (topics?.includes(filterType) || filterType === "Topics") && (
                <center style={{ marginTop: "20px" }}>
                  <p>
                    Select a{" "}
                    <span
                      onClick={handleOpen}
                      style={{ color: "#8d0792", cursor: "pointer" }}
                    >
                      Topic
                    </span>
                  </p>
                </center>
              )
            )}
          </div>
        </section>
        <section></section>
      </div>
    </div>
  );
};

export default News;
